import { USER_STATUS_COLORS } from "./colors";
import { getEffectiveAdminRoleName, getEffectiveUserRoleName, hasOrganizationManageAccess, ORGANIZATION_ROLES, USER_ASSIGNMENT_ROLES, GENERIC_STATUS, isWaSmbUser } from "../../../utils/constants";

export const PRIVATE_USER_FIRST_NAME_KEY = "private_user_first_name";
export const PRIVATE_USER_LAST_NAME_KEY = "private_user_last_name";
export const PRIVATE_USER_EMAIL_KEY = "private_user_email";
export const ORGANIZATION_ROLE_ID_KEY = "organization_role_id";
export const USER_ORGANIZATION_STATUS_NAME_KEY = "user_organization_status_name";
export const USER_ORGANIZATION_ROLE_NAME_KEY = "user_organization_role_name";
export const CHRONOX_USER_ROLE_NAME_KEY = "chronox_user_role_name";
export const LAST_UPDATED_AT_TIMESTAMP_KEY = "last_updated_at_timestamp";
export const CHRONOX_USER_ROLE_ID_KEY = "chronox_user_role_id";

export const last_updated_at_timestamp_format = "YYYY-MM-DD HH:mm:ss";

export const userRolesToHaveAccessToAddMembers = [ORGANIZATION_ROLES["OWNER_ROLE"]?.toLowerCase(), ORGANIZATION_ROLES["ADMIN_ROLE"]?.toLowerCase()];
export const userAssignmentRolesToHaveAccessToAddMembers = [USER_ASSIGNMENT_ROLES["SUPER_OWNER_ROLE"]?.toLowerCase(), USER_ASSIGNMENT_ROLES["OWNER_ROLE"]?.toLowerCase(), USER_ASSIGNMENT_ROLES["DEVELOPER_ROLE"]?.toLowerCase(), USER_ASSIGNMENT_ROLES["ADMIN_ROLE"]?.toLowerCase()];

export const ADMIN_ASSIGNABLE_ROLES = [
  USER_ASSIGNMENT_ROLES["ADMIN_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["AGENT_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["AGENT_ADMIN_ROLE"]?.toLowerCase()
];

export const OWNER_ASSIGNABLE_ROLES = [
  USER_ASSIGNMENT_ROLES["OWNER_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["ADMIN_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["AGENT_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["AGENT_ADMIN_ROLE"]?.toLowerCase()
];

export const DEVELOPER_ASSIGNABLE_ROLES = [
  USER_ASSIGNMENT_ROLES["DEVELOPER_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["OWNER_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["ADMIN_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["AGENT_ROLE"]?.toLowerCase(),
  USER_ASSIGNMENT_ROLES["AGENT_ADMIN_ROLE"]?.toLowerCase()
];

export const handleStatusColor = (value) => {
  const colorConfig = USER_STATUS_COLORS[GENERIC_STATUS[value?.toUpperCase()]]; 
  
  return {
    backgroundColor: colorConfig?.BG_COLOR,
    color: colorConfig?.TEXT_COLOR,
    boxShadow: `0px 0px 2px ${colorConfig?.BOX_SHADOW_COLOR}`
  }
}

export const hasPermissionToUpdateUser = (rowDetails, userDetail, userAssignmentRoleData, apiRoutesPermissionAssignment) => {

  // Can't update or delete the wa_smb_user.
  if(isWaSmbUser(rowDetails?.private_user_email)) {
    return {
        flagEditUserAccess: false,
        flagDeleteUserAccess: false
    }
  }

  const userRole = getEffectiveUserRoleName(userDetail);
  const adminRole = getEffectiveAdminRoleName(userDetail);

  const targetUserOrganizationRole = rowDetails?.user_organization_role_name?.toLowerCase();

  let targetUserAssignmentRole = null;
  const chronoxUserRole = getOrganizationNewRole(userAssignmentRoleData, rowDetails?.user_assignment_id);
  if (chronoxUserRole) {
    targetUserAssignmentRole = chronoxUserRole?.chronox_user_role_name?.toLowerCase();
  }

  const targetUserEmail = rowDetails?.private_user_email;
  const userEmail = userDetail?.user_email;

  const ownerRole = ORGANIZATION_ROLES["OWNER_ROLE"].toLowerCase();
  const isMemberOwner = targetUserOrganizationRole === ownerRole;
  const isMemberNotOwner = !isMemberOwner;
  const isSameUser = userEmail === targetUserEmail;

  let flagEditUserAccess = false;
  let flagDeleteUserAccess = false;

  if(!hasOrganizationManageAccess(apiRoutesPermissionAssignment, userDetail)) {
    return {
      flagEditUserAccess,
      flagDeleteUserAccess
    } 
  }

  if (isSameUser) {
    return {
      flagEditUserAccess,
      flagDeleteUserAccess
    }
  }

  // Helper function to check if current user can manage the target user's role
  const canManageTargetRole = (allowedRoles) => {
    return targetUserAssignmentRole && allowedRoles.includes(targetUserAssignmentRole);
  };

  // Helper function to get user access permissions with default values
  const getUserAccessPermissions = (allowedRoles, defaultEdit = true, defaultDelete = true) => {
    if (targetUserAssignmentRole) {
      const hasPermission = canManageTargetRole(allowedRoles);
      return { edit: hasPermission, delete: hasPermission };
    } else {
      return { edit: defaultEdit, delete: defaultDelete };
    }
  };

  let permissions = { edit: false, delete: false };

  // Determine permissions based on user role
  switch (userRole) {
    case USER_ASSIGNMENT_ROLES["SUPER_OWNER_ROLE"]?.toLowerCase():
      permissions = { edit: true, delete: true };
      break;

    case USER_ASSIGNMENT_ROLES["DEVELOPER_ROLE"]?.toLowerCase():
      permissions = getUserAccessPermissions(DEVELOPER_ASSIGNABLE_ROLES, true, true);
      break;

    case USER_ASSIGNMENT_ROLES["OWNER_ROLE"]?.toLowerCase():
      permissions = getUserAccessPermissions(OWNER_ASSIGNABLE_ROLES, true, true);
      break;

    case adminRole:
      permissions = getUserAccessPermissions(ADMIN_ASSIGNABLE_ROLES, isMemberNotOwner, isMemberNotOwner);
      break;

    case ownerRole:
      permissions = getUserAccessPermissions(OWNER_ASSIGNABLE_ROLES, true, true);
      break;
  }

  return {
    flagEditUserAccess: permissions.edit,
    flagDeleteUserAccess: permissions.delete
  };
}

export const checkAccessToEditUser = (rowDetails) => {
  return rowDetails?.user_organization_role_name?.toLowerCase() == "organization owner";
}

export const userDataFromOrganizationDetailResponse = (organizationDetailResponse, private_user_email) => {
  return organizationDetailResponse?.find((user) => user?.private_user_email == private_user_email);
}

export const getOrganizationNewRole = (userAssignmentRoleData, user_assignment_id) => {
  return userAssignmentRoleData?.find((role) => role?.user_assignment_id == user_assignment_id);
}

export const getCurrentOrganizationDetails = (organizationDetails, organization_id) => {
  return organizationDetails?.find((organization) => Number(organization?.organization_id) == Number(organization_id));
}